//** The component names - needed for updating state */
export function saveAndEmailFieldNames(person) {
  return {
    EMAIL_ADDRESS: `${person}_emailAddress`,
    CONTACT_NUMBER: `${person}_contactNumber`,
  };
}

export function gettingStartedFieldNames(person) {
  return {
    PEOPLE_QUESTION: `${person}_peopleQuestion`,
    RESIDENT_QUESTION: `${person}_residentQuestion`,
    FIRST_NAME: `${person}_firstName`,
    GENDER: `${person}_gender`,
    DOB: `${person}_dob`,
    TOBACCO_QUESTION: `${person}_tobaccoQuestion`,
    ...saveAndEmailFieldNames(person),
  };
}

export function yourDetailsContactFieldNames(person) {
  return {
    EMAIL_ADDRESS: `${person}_emailAddress`,
    CONTACT_NUMBER: `${person}_contactNumber`,
    STATE: `${person}_state`,
    PROMO_CODE: `${person}_promoCode`,
    TOBACCO_QUESTION: `${person}_tobaccoQuestion`,
    OTHER_ALLIANZ_INSURANCE_QUESTION: `${person}_otherAllianzInsuranceQuestion`,
    OTHER_ALLIANZ_INSURANCE_LIST: `${person}_otherAllianzInsuranceList`,
    COMMUNICATION_CONSENT: `${person}_callbackConsent`,
    // ADDITIONAL_HOLDER_TITLE: 'additionalPolicyHolderTitle',
    // ADDITIONAL_HOLDER_FIRSTNAME: 'additionalPolicyHolderFirstName',
    // ADDITIONAL_HOLDER_SURNAME: 'additionalPolicyHolderSurname',
    // ADDITIONAL_HOLDER_DOB: 'additionalPolicyHolderDOB',
  };
}

export function aboutYouPersonalInformationFieldNames(person) {
  return {
    TITLE: `${person}_title`,
    FIRST_NAME: `${person}_firstName`,
    SURNAME: `${person}_surname`,
    STATE: `${person}_state`,
    GENDER: `${person}_gender`,
    DOB: `${person}_dob`,
    TOBACCO_QUESTION: `${person}_tobaccoQuestion`,
  };
}

export function aboutYouDeclarationsFieldNames(person) {
  return {
    RESIDENT_QUESTION: `${person}_residentQuestion`,
    OTHER_ALLIANZ_INSURANCE_QUESTION: `${person}_otherAllianzInsuranceQuestion`,
    ABOUT_YOU_DISCLOSURE_TC: 'aboutYouDisclosureTc',
  };
}

export function selectCoverFieldNames(person) {
  return {
    LIFE_COVER: `${person}_lifeCover`,
    CRITICAL_ILLNESS_COVER: `${person}_illnessCover`,
    TRAUMA_COVER: `${person}_traumaCover`,
    PERMANENT_DISABILITY_COVER: `${person}_permanentDisabilityCover`,
    OCCUPATION_LIST: `${person}_occupationList`,
    TERMS_AND_CONDITIONS: `${person}_termsAndConditions`,
    PROMO_CODE: `${person}_promoCode`,
  };
}

export function quoteSummaryFieldNames(person) {
  return {
    LIFE_COVER: `${person}_lifeCover`,
    CRITICAL_ILLNESS_COVER: `${person}_illnessCover`,
    TRAUMA_COVER: `${person}_traumaCover`,
    PERMANENT_DISABILITY_COVER: `${person}_permanentDisabilityCover`,
    OCCUPATION_LIST: `${person}_occupationList`,
  };
}

export function paymentContactDetailsFieldNames() {
  return {
    POLICY_MAILING_ADDRESS_BASE: 'policyMailingAddress', //* This is the one we pass in to the Address Choice Component
    POLICY_MAILING_ADDRESS_FULL: 'policyMailingAddressFull', //! Autocomplete for policy mailing address
    POLICY_MAILING_ADDRESS_LEVEL_NUMBER: 'policyMailingAddressLevelNumber',
    POLICY_MAILING_ADDRESS_UNIT_NUMBER: 'policyMailingAddressUnitNumber',
    POLICY_MAILING_ADDRESS_STREET_NUMBER: 'policyMailingAddressStreetNumber',
    POLICY_MAILING_ADDRESS_STREET_NUMBER_TYPE: 'policyMailingAddressStreetNumberType',
    POLICY_MAILING_ADDRESS_STREET_NAME: 'policyMailingAddressStreetName',
    POLICY_MAILING_ADDRESS_STREET_NAME_TYPE: 'policyMailingAddressStreetNameType',
    POLICY_MAILING_ADDRESS_POSTCODE_SUBURB: 'policyMailingAddressPostcodeSuburb',

    BOTH_ADDRESSES_THE_SAME: 'bothAddressesTheSame',
    RESIDENTIAL_ADDRESS_BASE: 'residentialAddress',
    RESIDENTIAL_ADDRESS_FULL: 'residentialAddressFull', //! Autocomplete for residential mailing address
    RESIDENTIAL_ADDRESS_LEVEL_NUMBER: 'residentialAddressLevelNumber',
    RESIDENTIAL_ADDRESS_UNIT_NUMBER: 'residentialAddressUnitNumber',
    RESIDENTIAL_ADDRESS_STREET_NUMBER: 'residentialAddressStreetNumber',
    RESIDENTIAL_ADDRESS_STREET_NUMBER_TYPE: 'residentialAddressStreetNumberType',
    RESIDENTIAL_ADDRESS_STREET_NAME: 'residentialAddressStreetName',
    RESIDENTIAL_ADDRESS_STREET_NAME_TYPE: 'residentialAddressStreetNameType',
    RESIDENTIAL_ADDRESS_POSTCODE_SUBURB: 'residentialAddressPostcodeSuburb',
    POLICY_DOCUMENT_REQUEST_TYPE: 'policyDocumentRequestType',

    PAYMENT_CONTACT_NUMBER: 'paymentContactNumber',
    PAYMENT_CONTACT_EMAIL: 'paymentContactEmail',

    ADDITIONAL_HOLDER_TITLE: 'additionalPolicyHolderTitle',
    ADDITIONAL_HOLDER_FIRSTNAME: 'additionalPolicyHolderFirstName',
    ADDITIONAL_HOLDER_SURNAME: 'additionalPolicyHolderSurname',
    ADDITIONAL_HOLDER_DOB: 'additionalPolicyHolderDOB',
  };
}

export function paymentDetailsFieldNames() {
  return {
    BANK_PAYMENT_PERMISSION_GRANTED: 'bankPaymentPermissionGranted',
    BANK_BSB: 'bankBSB',
    BANK_ACCOUNT_NUMBER: 'bankAccountNumber',
    BANK_ACCOUNT_NAME: 'bankAccountName',
    BANK_NAME_OF_FINANCIAL_INSTITUTION: 'bankNameOfFinancialInstitution',
  };
}

export function aboutYouDisclosureFieldNames() {
  return {
    ABOUT_YOU_DISCLOSURE_TC: 'aboutYouDisclosureTc',
  };
}

export function policyOutcomeFieldNames(person) {
  return {
    LIFE_COVER: `${person}_lifeCover`,
    CRITICAL_ILLNESS_COVER: `${person}_illnessCover`,
    TRAUMA_COVER: `${person}_traumaCover`,
    PERMANENT_DISABILITY_COVER: `${person}_permanentDisabilityCover`,
    OCCUPATION_LIST: `${person}_occupationList`,
    ACCEPT_OFFER: 'acceptOffer',
    ACCEPT_UPGRADE: 'acceptUpgrade',
    EXISTING_POLICY_NUMBER: 'existingPolicyNumber',
  };
}
//----------------------------------------------------------------
//** Contact Center */
export function contactCenterOpeningScriptFieldNames() {
  return {
    OPENING_QUESTION: 'openingQuestion', //! Remove?
    PRIVACY_RECORDING_QUESTION: 'privacyRecordingQuestion',
    ADDITIONAL_SUMMARY_QUESTION: 'additionalSummaryQuestion',
    OPT_OUT_DIRECT_MARKETING_QUESTION: 'optOutDirectMarketingQuestion',
  };
}

export function contactCenterGettingStartedFieldNames(person) {
  return {
    TITLE: `${person}_title`,
    FIRST_NAME: `${person}_firstName`,
    SURNAME: `${person}_surname`,
    GENDER: `${person}_gender`,
    DOB: `${person}_dob`,
    TOBACCO_QUESTION: `${person}_tobaccoQuestion`,
    EMAIL_ADDRESS: `${person}_emailAddress`,
    CONTACT_NUMBER: `${person}_contactNumber`,
    OPT_OUT_DIRECT_MARKETING_QUESTION: 'optOutDirectMarketingQuestion',
  };
}

export function contactCenterPolicyOutcomeFieldNames() {
  return {
    LIFE_ADDITIONAL_CONDITIONS: `additionalConditionsLife`,
    CRITICAL_ILLNESS_ADDITIONAL_CONDITIONS: `additionalConditionsCriticalIllness`,
    PERMANENT_DISABILITY_ADDITIONAL_CONDITIONS: `additionalConditionsUnableToWork`,
  };
}

export function contactCenterSaveAndEmailFieldNames(person) {
  return {
    EMAIL_ADDRESS: `${person}_emailAddress`,
    CONTACT_NUMBER: `${person}_contactNumber`,
    OPT_OUT_DIRECT_MARKETING_QUESTION: 'optOutDirectMarketingQuestion',
  };
}

export const CC_RETRIEVE_QUOTE_FIELDNAME = {
  QUOTE_NUMBER: 'quoteNumber',
  PHONE_NUMBER: 'phoneNumber',
  SURNAME: 'surname',
  DATE_OF_BIRTH: 'dateOfBirth',
};
